module.exports = __webpack_public_path__ + "assets/logo-white.0fa5c09b.svg";